import jwtDecode from 'jwt-decode'
import { Buffer } from 'buffer'

export const decodeJwt = (token: string): any => {
	const decoded = jwtDecode(token)
	return decoded
}

export const decodeUrl = (locationSearch: string) => {
	const urlSearchParams = new URLSearchParams(locationSearch)

	const params = Object.fromEntries(urlSearchParams.entries())
	return JSON.parse(Buffer.from(params.payload, 'base64').toString())
}
